export const STATUS_OPTIONS = [
  { value: "Pending", label: "Pending" },
  { value: "Published", label: "Published" },
  { value: "Rejected", label: "Rejected" },
  { value: "Verified", label: "Verified" },
  { value: "Unverified", label: "Unverified" }
];
